module.exports = __webpack_public_path__ + "assets/img/copy.33755770.svg";